import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrvFormDateInputComponent } from './prv-form-date-input/prv-form-date-input.component';
import { ScaleToFitDirective } from '../directives/scale-to-fit.directive';
import { AutoGrowDirective } from '../directives/auto-grow.directive';
import { RvFieldErrorDirective } from '../directives/rv-field-error.directive';
import { RtPageComponent } from './rt-page/rt-page.component';
import { RtHeroComponent } from './rt-hero/rt-hero.component';
import { RtTipComponent } from './rt-tip/rt-tip.component';
import { RtStatusComponent } from './rt-status/rt-status.component';
import { RtFilterChipsComponent } from './rt-filter-chips/rt-filter-chips.component';
import { RtEditorBarComponent } from './rt-editor-bar/rt-editor-bar.component';
import { RtMissingComponent } from './rt-missing/rt-missing.component';
import { RtStatusBannerComponent } from './rt-status-banner/rt-status-banner.component';
import { RtQuarterSelectComponent } from './rt-quarter-select/rt-quarter-select.component';
import { RtToastComponent } from './rt-toast/rt-toast.component';
import { RtLoadingComponent } from './rt-loading/rt-loading.component';
import { RtLoginIntroComponent } from './rt-login-intro/rt-login-intro.component';
import { RtComboboxComponent } from './rt-combobox/rt-combobox.component';
import { RtWhatsNewComponent } from './rt-whats-new/rt-whats-new.component';

const SHARED = [
  RtPageComponent,
  RtHeroComponent,
  RtTipComponent,
  RtStatusComponent,
  RtFilterChipsComponent,
  RtEditorBarComponent,
  RtMissingComponent,
  RtStatusBannerComponent,
  RtQuarterSelectComponent,
  RtToastComponent,
  RtLoadingComponent,
  RtLoginIntroComponent,
  RtComboboxComponent,
  RtWhatsNewComponent,
  PrvFormDateInputComponent,
  ScaleToFitDirective,
  AutoGrowDirective,
  RvFieldErrorDirective,
];

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: SHARED,
  exports: SHARED,
})
export class ComponentsModule { }
